export default "__VITE_ASSET__hZIJDjud__"